var map = {
	"./Layer21.png": 22166,
	"./aladdin-thumb.png": 37618,
	"./aladdin.png": 50324,
	"./banner-jackpot-mobile.png": 64173,
	"./banner-jackpot-old.png": 79479,
	"./banner-jackpot.png": 71826,
	"./cartel-thumb.png": 11931,
	"./cartel.png": 60078,
	"./cleopatra-thumb.png": 24171,
	"./cleopatra.png": 65506,
	"./fairness.png": 46163,
	"./flag-cn.png": 474,
	"./flag-en.png": 44292,
	"./flag-es.png": 76464,
	"./flag-kr.png": 31543,
	"./flag-tr.png": 10679,
	"./icon-bitcoin.png": 52546,
	"./icon-eos.png": 40565,
	"./icon-info.png": 95143,
	"./icon-kylin.png": 93444,
	"./iframe-holder.png": 78325,
	"./img-hero.png": 95632,
	"./jackpot-chest.png": 90293,
	"./jackpot.png": 7545,
	"./king-arthur-thumb.png": 32050,
	"./king-arthur.png": 29011,
	"./logo-anchor.png": 98917,
	"./logo-scatter.png": 98414,
	"./logo-tokenpocket.png": 91648,
	"./luckyslot-logo.png": 1650,
	"./moregames.png": 36553,
	"./new-corner-label.png": 1410,
	"./night-of-fear-thumb.png": 7644,
	"./night-of-fear.png": 9576,
	"./pirates-thumb.png": 16968,
	"./pirates.png": 55458,
	"./samurai-thumb.png": 42313,
	"./samurai.png": 86665,
	"./spymaster-thumb.png": 75071,
	"./spymaster.png": 38657,
	"./surfin-thumb.png": 94619,
	"./surfin.png": 60325,
	"./thebigfive-thumb.png": 1417,
	"./thebigfive.png": 43884,
	"./tigerland-thumb.png": 83632,
	"./tigerland.png": 9908,
	"./wildwest-thumb.png": 18530,
	"./wildwest.png": 19030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;